import moment from "moment";

export const CREATE_MILESTONE_DEFAULT_VALUES = {
  epic_name: "",
  description: "",
  start_date: null,
  target_release_date: null,
};

export function buildCreateMilestonePayload({ boardId, formData }) {
  return {
    board_id: boardId,
    data: {
      ...formData,
      ...(formData.start_date && {
        start_date: moment(formData.start_date).format("YYYY-MM-DD"),
      }),
      ...(formData.target_release_date && {
        target_release_date: moment(formData.target_release_date).format(
          "YYYY-MM-DD"
        ),
      }),
    },
  };
}
